export default (url?: string) => {
  const localeReg = /^\/([a-z]{2})(\/.*)?$/

  return localeReg.test(url ?? '')
}
